module.exports = __webpack_public_path__ + "img/SketchPngb1f62fb0a4b25733d144e3ba22b1c16b54932beac2856e1da7c2cd12b8ed8b2d.6ae36ba8.png";